import { fetchGuilds, fetchGuildItems, saveItem, fetchEmojis } from '../api'
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Breadcrumb, Select, Button, Input, Space, Divider, Form, Popover, InputNumber, Collapse, Switch, message, Typography, ColorPicker } from 'antd';
import { LoadingOutlined, DeleteOutlined, CopyOutlined, PlusCircleOutlined, DownOutlined } from '@ant-design/icons';
import { runes } from 'runes2';
import { EmojiStyle } from 'emoji-picker-react';
import EmojiPicker from 'emoji-picker-react';
import { validatorName } from "../validators/item"
import { login } from '../api'
import botconfig from '../botconfig';
//import { DashboardHeader } from '../components/DashboardHeader';
import { AppHeader } from '../components/AppHeader';
const { Text } = Typography
export function ItemsPage() {
    const { guildId } = useParams();
    const [loadingGuild, setLoadingGuild] = useState(true);
    const [loadingItem, setLoadingItem] = useState(true);
    const [items, setItems] = useState()
    const [item, setItem] = useState()
    const [copyItem, setCopyItem] = useState()
    const [valid, setValid] = useState(true)
    const [emojis, setEmojis] = useState([])
    const [state, setState] = useState(0)
    const [open, setOpen] = useState(false);
    const [shopInfinity, setShopInfinity] = useState()
    const [shopAmount, setShopAmount] = useState()
    const [messageApi, contextHolder] = message.useMessage()
    const [guild, setGuild] = useState()
    function errorMessage(error) {
        if (error) console.error(error)
        messageApi.open({
            type: 'error',
            content: `Произошла ошибка :( ${error.message}`,
        });
    }
    useEffect(() => {
        async function preload() {
            let localItem = JSON.parse(localStorage.getItem("wetbot"))
            if (!localItem?.token) return window.location.replace(`${botconfig.redirect_uri}${botconfig.website_port}/login`)
            if (localItem.token.expires_at <= Date.now()) {
                localStorage.removeItem("wetbot")
                return window.location.replace(`${botconfig.redirect_uri}${botconfig.website_port}/login`)
            }
            let guild
            try {
                const guilds = await fetchGuilds(localItem.user.id, localItem.token.access_token)
                guild = guilds.find(guild => guild.id === guildId)
                if (!guild) return errorMessage()
                setGuild(guild)
            } catch (err) {
                return errorMessage(err)
            }
            setLoadingGuild(false)
            try {
                const items = await fetchGuildItems(guild.id)
                setItems(items)    
            } catch (err) {
                return errorMessage(err)
            }
            setLoadingItem(false)
            try {
                const emojis = await fetchEmojis(localItem.token.access_token)
                setEmojis(emojis)    
            } catch (err) {
                return errorMessage(err)
            }
        }
        preload()
    }, [])
    async function save() {
        setLoadingItem(true)
        let localItem = JSON.parse(localStorage.getItem("wetbot"))
        try {
            await saveItem(copyItem, localItem.token.access_token, localItem.user.userId)    
        } catch (err) {
            setLoadingItem(false)
            return errorMessage(err)
        }
        setItem({
            ...copyItem
        })
        setItems([...items.filter(e => e.itemID !== copyItem.itemID), copyItem])
        setLoadingItem(false)
    }
    async function cancel() {
        setState(state + 1)
        setShopInfinity(item.shop.amount === Infinity ? true : false)
        setShopAmount(item.shop.amount)
        setCopyItem({
            ...item
        })
    }
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    //const maxItemsReached = items.length >= settings?.max_items
    return (
        <>
            {contextHolder}
            <AppHeader></AppHeader>
            <div style={{ padding: '0 24px 24px', backgroundColor: "var(--bg-primary)" }}>
                <Breadcrumb style={{ margin: '16px 0' }}>
                    <Breadcrumb.Item><a href={`${botconfig.root_path}${botconfig.website_port}/servers`}>Серверы</a></Breadcrumb.Item>
                    <Breadcrumb.Item>{loadingGuild ? <LoadingOutlined /> : <a href={`${botconfig.root_path}${botconfig.website_port}/dashboard/${guild?.id}`}>{guild?.name}</a>}</Breadcrumb.Item>
                    <Breadcrumb.Item>📦Предметы</Breadcrumb.Item>
                </Breadcrumb>
                <div
                    style={{
                        padding: 24,
                        margin: 0,
                        minHeight: "100vh",
                        backgroundColor: "var(--bg-primary)"
                    }}
                >
                    <div style={{ display: "gird" }}>
                        <Select
                            showSearch
                            onSelect={value => {
                                const item = items.find(e => e.itemID === value)
                                setItem({
                                    ...item,
                                    name: item.name
                                })
                                setShopInfinity(item.shop.amount === Infinity ? true : false)
                                setShopAmount(item.shop.amount)
                                setCopyItem({
                                    ...item,
                                    name: item.name
                                })
                            }}
                            loading={loadingItem}
                            disabled={loadingItem}
                            style={{ width: 400, display: "gird", minWidth: 200, width: "40vw" }}
                            placeholder="Выбери предмет"
                            optionFilterProp="label"
                            optionLabelProp="label"
                            options={items?.map(item => ({
                                label: item.name,
                                value: item.itemID,
                                emoji: item.emoji,
                                icon: item.emojiURL
                            }))}
                            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            optionRender={(option) => (
                                <Space>
                                    {option.data.icon ? <img style={{ width: 20 }} src={option.data.icon} alt={option.data.label} /> : option.data.emoji}<Text>{option.data.label}</Text>
                                </Space>
                            )}
                        />
                        {copyItem ? <>
                            <Divider></Divider>
                            <Form
                                layout="vertical"
                                initialValues={{
                                    item_name: copyItem.name,
                                    description: copyItem.description,
                                    image: copyItem.image?.slice(copyItem.image.indexOf("https://") + 8),
                                    color: copyItem.hex,
                                    rarity: copyItem.rarity,
                                    sort: copyItem.sort
                                }}
                                key={`${copyItem.itemID}_${state}`}
                            >
                                <div style={{ display: "flex", justifyContent: "flex-start", flexWrap: "wrap", gap: 5 }}>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ display: "flex", alignItems: "flex-start", marginRight: 5, marginTop: 5 }}>
                                            <Popover
                                                trigger="click"
                                                open={open}
                                                onOpenChange={handleOpenChange}
                                                content={(<EmojiPicker
                                                    open={open}
                                                    emojiStyle={EmojiStyle.NATIVE}
                                                    previewConfig={{
                                                        defaultEmoji: "1f60a",
                                                        defaultCaption: "Как твое настроение?",
                                                        showPreview: true
                                                    }}
                                                    onEmojiClick={(emojiData) => {
                                                        setCopyItem({
                                                            ...copyItem,
                                                            emoji: emojiData.emoji,
                                                            emojiURL: emojiData.isCustom ? emojiData.imageUrl : undefined
                                                        })
                                                    }}
                                                    categories={[
                                                        guild.premium ? {
                                                            category: 'custom',
                                                            name: 'Discord эмодзи'
                                                        } : undefined,
                                                        {
                                                            category: 'smileys_people',
                                                            name: 'Лица'
                                                        },
                                                        {
                                                            category: 'animals_nature',
                                                            name: 'Животные, природа'
                                                        },
                                                        {
                                                            category: 'food_drink',
                                                            name: 'Еда, напитки'
                                                        },
                                                        {
                                                            category: 'travel_places',
                                                            name: 'Путешествие'
                                                        },
                                                        {
                                                            category: 'activities',
                                                            name: 'Спорт и активности'
                                                        },
                                                        {
                                                            category: 'objects',
                                                            name: 'Предметы'
                                                        },
                                                        {
                                                            category: 'symbols',
                                                            name: 'Символы'
                                                        },
                                                        {
                                                            category: 'flags',
                                                            name: 'Флаги'
                                                        }
                                                    ].filter(e => e)}
                                                    customEmojis={emojis.map(e => {
                                                        return {
                                                            names: [e.name],
                                                            imgUrl: e.url,
                                                            id: e.id
                                                        }
                                                    })}
                                                />)}
                                            >
                                                {copyItem.emojiURL ? <Button shape="circle" style={{ backgroundImage: `url(${copyItem.emojiURL})`, backgroundSize: "contain", backgroundRepeat: "no-repeat", width: "60px", height: "60px", backgroundPosition: "center" }}></Button> : <Button style={{ width: "60px", height: "60px" }} shape="circle"><span style={{ fontSize: "30px" }}>{copyItem.emoji}</span></Button>}
                                            </Popover>
                                        </div>
                                        <Form.Item
                                            style={{ margin: 0 }}
                                            name="item_name"
                                            label="Название предмета"
                                            rules={
                                                [
                                                    {
                                                        required: true, message: 'Пожалуйста, введите название предмета', whitespace: true
                                                    },
                                                    {
                                                        validator: (rule, value) => {
                                                            const promise = validatorName(rule, value, items, item)
                                                            promise.then(
                                                                result => setValid(true),
                                                                error => setValid(false)
                                                            )
                                                            return promise
                                                        }
                                                    }
                                                ]
                                            }
                                        >
                                            <Input
                                                count={{
                                                    show: true,
                                                    max: 30,
                                                    strategy: (txt) => runes(txt).length,
                                                    exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                                }}
                                                onChange={(input) => {
                                                    setCopyItem({
                                                        ...copyItem,
                                                        name: input.target.value
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                    </div>
                                    <Form.Item
                                        style={{ margin: 0 }}
                                        name="rarity"
                                        label="Название редкости"
                                        rules={
                                            [
                                                {
                                                    required: true, message: 'Пожалуйста, введите название редкости', whitespace: true
                                                }
                                            ]
                                        }
                                    >
                                        <Input
                                            count={{
                                                show: true,
                                                max: 45,
                                                strategy: (txt) => runes(txt).length,
                                                exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                            }}
                                            onChange={(input) => {
                                                if (input.target.value.trim().length === 0) setValid(false)
                                                else setValid(true)
                                                setCopyItem({
                                                    ...copyItem,
                                                    rarity: input.target.value
                                                })
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        style={{ margin: 0 }}
                                        name="sort"
                                        label="Порядок сортировки"
                                    >
                                        <InputNumber min={1} max={1000} onChange={(value) => {
                                            setCopyItem({
                                                ...copyItem,
                                                sort: value
                                            })
                                        }} />
                                    </Form.Item>
                                    <Form.Item
                                        style={{ margin: 0, marginhRight: 30 }}
                                        name="color"
                                        label="Цвет предмета"
                                    >
                                        <ColorPicker
                                            size="medium"
                                            showText
                                            disabledAlpha
                                            onChange={(value, hex) => {
                                                setCopyItem({
                                                    ...copyItem,
                                                    hex: hex
                                                })
                                            }}
                                        />
                                    </Form.Item>
                                </div>
                                <Form.Item
                                    style={{ margin: 0 }}
                                    name="description"
                                    label="Описание предмета"
                                    rules={
                                        [
                                            {
                                                required: true, message: 'Пожалуйста, введите описание предмета', whitespace: true
                                            }
                                        ]
                                    }
                                >
                                    <Input.TextArea rows={4}
                                        count={{
                                            show: true,
                                            max: 200,
                                            strategy: (txt) => runes(txt).length,
                                            exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                        }}
                                        onChange={(input) => {
                                            if (input.target.value.trim().length === 0) setValid(false)
                                            else setValid(true)
                                            setCopyItem({
                                                ...copyItem,
                                                description: input.target.value
                                            })
                                        }}
                                    />
                                </Form.Item>
                                <div style={{ display: "flex" }}>
                                    <Form.Item
                                        style={{ margin: 0, flexGrow: 1 }}
                                        name="image"
                                        label="Изображение предмета"
                                    >
                                        <Input
                                            addonBefore="https://"
                                            placeholder="Ссылка"
                                            onChange={(input) => {
                                                setCopyItem({
                                                    ...copyItem,
                                                    image: input.target.value ? "https://" + input.target.value : undefined
                                                })
                                            }}
                                        />
                                    </Form.Item>
                                    {copyItem.image?.length ? <img src={copyItem.image} alt="" style={{ width: 128, height: 128, marginTop: 30 }} /> : undefined}
                                </div>
                            </Form>
                            <Collapse items={[
                                {
                                    key: 'shop',
                                    label: 'Магазин',
                                    children: <div style={{ display: "inline-grid", justifyItems: "start" }}>
                                        <Switch key={`isShop_${copyItem.itemID}_${state}`} defaultChecked={copyItem.shop.inShop} checkedChildren="В магазине" unCheckedChildren="Не в магазине" onChange={(value) => {
                                            setCopyItem({
                                                ...copyItem,
                                                shop: {
                                                    ...copyItem.shop,
                                                    inShop: value
                                                }
                                            })
                                        }} />
                                        <Popover content={
                                            <div style={{ display: "inline-grid", justifyItems: "center", gap: "0.5rem" }}>
                                                <Switch
                                                    checkedChildren="Бесконечно"
                                                    unCheckedChildren="Не бесконечно"
                                                    key={`infinity_${copyItem.itemID}_${state}`}
                                                    defaultChecked={copyItem.shop.amount === Infinity}
                                                    onChange={(value) => {
                                                        setCopyItem({
                                                            ...copyItem,
                                                            shop: {
                                                                ...copyItem.shop,
                                                                amount: value ? Infinity : shopAmount !== Infinity ? shopAmount : 1
                                                            }
                                                        })
                                                        setShopInfinity(value)
                                                    }}
                                                />
                                                <InputNumber style={{ width: 300 }} min={0} max={999999999999999} key={`shopAmount_${shopInfinity}_${state}`} defaultValue={copyItem.shop.amount} disabled={copyItem.shop.amount === Infinity} onChange={(value) => {
                                                    setShopAmount(value)
                                                    setCopyItem({
                                                        ...copyItem,
                                                        shop: {
                                                            ...copyItem.shop,
                                                            amount: value
                                                        }
                                                    })
                                                }} />
                                            </div>
                                        }>
                                            <Button type="link" style={{ padding: 0, width: 100 }}>
                                                Количество: {copyItem.shop.amount}<DownOutlined />
                                            </Button>
                                        </Popover>

                                    </div>,
                                },
                                {
                                    key: 'craft',
                                    label: 'Крафт',
                                    children: <p></p>,
                                },
                                {
                                    key: 'case',
                                    label: 'Кейс',
                                    children: <p></p>,
                                },
                                {
                                    key: 'use',
                                    label: 'Использование',
                                    children: <p></p>,
                                },
                                {
                                    key: 'obtaining',
                                    label: 'Способы получения',
                                    children: <p></p>,
                                },
                                {
                                    key: 'properties',
                                    label: 'Свойства',
                                    children: <p></p>,
                                },
                                {
                                    key: 'permissions',
                                    label: 'Права',
                                    children: <p></p>,
                                },
                                {
                                    key: 'cooldowns',
                                    label: 'Кулдауны',
                                    children: <p></p>,
                                },
                            ]} style={{ marginTop: "1rem" }} />
                        </> : undefined}
                        <div style={{ insetBlockEnd: 20, position: "fixed", right: 20, gap: 10, display: item && copyItem && JSON.stringify(item) !== JSON.stringify(copyItem) ? "flex" : "none" }}>
                            {valid && item && copyItem && JSON.stringify(item) !== JSON.stringify(copyItem) ?
                                <>
                                    <button
                                        className='button success'
                                        style={{ height: 30, padding: "0 5vw", color: "white" }}
                                        onClick={(e) => save()}
                                        id={`save_btn_${copyItem.itemID}`}
                                    >Сохранить</button>
                                </>
                                : undefined}
                            {item && copyItem && JSON.stringify(item) !== JSON.stringify(copyItem) ?
                                <button
                                    className='button danger'
                                    style={{ height: 30, padding: "0 5vw", color: "white" }}
                                    onClick={() => cancel()}
                                    id={`cancel_btn_${copyItem.itemID}`}
                                >Отменить</button>
                                : undefined}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}